<div class="mobile-shell">

  
    <div class="content">
  
      <h2 class="section-heading">How would you like to pay?</h2>
  
      <div
        class="payment-card"
        [class.payment-card-selected]="selectedMethod === 'card'"
        (click)="selectedMethod = 'card'"
      >
        <p-radioButton
          name="paymentMethod"
          value="card"
          [(ngModel)]="selectedMethod">
        </p-radioButton>
  
        <div class="payment-copy">
          <div class="payment-title">Debit or Credit Card</div>
          <div class="payment-description">
            Add money using your international<br />
            card.
          </div>
        </div>
  
        <i class="pi pi-credit-card payment-icon"></i>
      </div>
  
      <div
        class="payment-card"
        [class.payment-card-selected]="selectedMethod === 'bank'"
        (click)="selectedMethod = 'bank'"
      >
        <p-radioButton
          name="paymentMethod"
          value="bank"
          [(ngModel)]="selectedMethod">
        </p-radioButton>
  
        <div class="payment-copy">
          <div class="payment-title">Instant Bank Transfer</div>
          <div class="payment-description">
            Add money from your international<br />
            bank account.
          </div>
        </div>
  
        <i class="pi pi-building-columns payment-icon"></i>
      </div>
  
      <h3 class="field-heading">Where are you transferring from?</h3>
  
      <!-- Inline expandable dropdown -->
      <div class="country-select" [class.country-select-open]="dropdownOpen">
  
        <button
          type="button"
          class="country-trigger"
          (click)="toggleDropdown()"
        >
          <span class="selected-country">
            <span *ngIf="selectedCountry" class="country-flag" [ngClass]="selectedCountry.flag">              
            </span>
  
            <span>
              {{ selectedCountry?.label || 'Your bank location *' }}
            </span>
          </span>
  
          <i
            class="pi"
            [class.pi-chevron-down]="!dropdownOpen"
            [class.pi-chevron-up]="dropdownOpen">
          </i>
        </button>
  
        <div class="country-options" *ngIf="dropdownOpen">
          <button
            type="button"
            class="country-option"
            *ngFor="let country of countries"
            [class.country-option-selected]="selectedCountry?.value === country.value"
            (click)="selectCountry(country)"
          >
            <span class="country-flag" [ngClass]="country.flag"></span>
            <span>{{ country.label }}</span>
          </button>
        </div>
  
      </div>
  
      <a (click)="openMessage()" class="help-link">
        <i class="pi pi-info-circle"></i>
        Can’t find your country?
      </a>

      <p-message severity="info" styleClass="custom-banner" *ngIf="showMessage">

        <ng-template pTemplate>
      
          <div class="banner-container">
      
            <i class="pi pi-info-circle banner-icon"></i>
      
            <div class="banner-content">
              <div class="banner-title">
                Can’t find your country?
              </div>
      
              <div class="banner-text">
                Diaspora transfers aren’t currently available in your country.
                We’re working to expand availability.
              </div>
            </div>
      
            <i class="pi pi-times banner-close"></i>
      
          </div>
      
        </ng-template>
      
      </p-message>
      
  
      <button
        pButton
        type="button"
        label="NEXT"
        class="next-button"
        (click)="onclick()"
        [disabled]="!selectedCountry">
      </button>
  
    </div>
  </div>
  